export const TRANSLATIONS_PT_ONBOARDING = {
  "homePublic.hero.eyebrow": "Visão ao vivo",
  "homePublic.hero.title": "Seu workspace em nível corporativo antes de conectar qualquer dado",
  "homePublic.hero.subtitle":
    "Explore um ambiente simulado com métricas anonimizadas para ver como o Innovadoc IA mantém as equipes alinhadas antes do go-live.",
  "homePublic.hero.ctaPrimary": "Criar minha conta",
  "homePublic.hero.ctaSecondary": "Entrar no meu workspace",
  "homePublic.hero.metrics.documents": "Documentos indexados",
  "homePublic.hero.metrics.latency": "Tempo médio de resposta",
  "homePublic.hero.metrics.compliance": "Cobertura de conhecimento",
  "homePublic.mock.eyebrow": "Telemetria simulada",
  "homePublic.mock.title": "Sinais gerados com dados seguros",
  "homePublic.mock.subtitle":
    "Os números se atualizam automaticamente para mostrar como a plataforma se comporta com tráfego ativo.",
  "homePublic.mock.cards.documents.label": "Documentos nesta semana",
  "homePublic.mock.cards.documents.detail": "Uploads únicos sincronizados nos últimos 7 dias",
  "homePublic.mock.cards.repositories.label": "Fontes conectadas",
  "homePublic.mock.cards.repositories.detail": "Drive, SharePoint, S3, Gmail e outros",
  "homePublic.mock.cards.users.label": "Assentos ativos",
  "homePublic.mock.cards.users.detail": "Membros que usam o chat e as automações",
  "homePublic.mock.cards.alerts.label": "Alertas de atenção",
  "homePublic.mock.cards.alerts.detail": "Itens de remediação pendentes para admins",
  "homePublic.features.eyebrow": "O que você recebe",
  "homePublic.features.title": "Pronto para enterprise desde o primeiro dia",
  "homePublic.features.subtitle": "Tudo o que precisa para testar a experiência sem tocar dados produtivos.",
  "homePublic.features.ingestion.title": "Ingestão sem atrito",
  "homePublic.features.ingestion.desc": "Solte pastas, encaminhe e-mails ou conecte repositórios em minutos.",
  "homePublic.features.security.title": "Segurança em primeiro lugar",
  "homePublic.features.security.desc": "Controles alinhados ao SOC 2, permissões granulares e isolamento por workspace.",
  "homePublic.features.operations.title": "Operações conscientes",
  "homePublic.features.operations.desc": "Dashboards ao vivo, alertas de saúde e filas de tarefas para humanos no loop.",
  "homePublic.plan.eyebrow": "Panorama do plano",
  "homePublic.plan.title": "Plano Starter com salvaguardas reais",
  "homePublic.plan.subtitle": "Projetado para líderes de inovação que validam experiências RAG com stakeholders internos.",
  "homePublic.plan.points.speed.title": "Pilotos mais rápidos",
  "homePublic.plan.points.speed.desc": "Provisione stores vetoriais dedicados e fluxos de chat prontos para uso.",
  "homePublic.plan.points.context.title": "Contexto confiável",
  "homePublic.plan.points.context.desc": "Detecta PII automaticamente, classifica repositórios e mantém trilha em cada chunk.",
  "homePublic.plan.points.support.title": "Implantação guiada",
  "homePublic.plan.points.support.desc": "Equipe de sucesso do cliente e office hours assíncronas para manter o ritmo.",
  "homePublic.plan.card.title": "O que está incluído",
  "homePublic.plan.card.subtitle": "10 usuários · 2 workspaces · 50K créditos de prompt · telemetria premium.",
  "homePublic.plan.card.ctaPrimary": "Começar piloto gratuito",
  "homePublic.plan.card.ctaSecondary": "Ver opções enterprise",
  "homePublic.testimonial.quote": "O ambiente simulado ajudou nosso time de compliance a aprovar o rollout em apenas uma semana.",
  "homePublic.testimonial.author": "Lucía Hernández",
  "homePublic.testimonial.role": "Líder de Transformação IA, Vectoris",
  "homePublic.cta.title": "Pronto para ver seus documentos ganhando vida?",
  "homePublic.cta.subtitle": "Ative o Innovadoc IA com dados fictícios hoje e conecte seus repositórios quando o jurídico liberar.",
  "homePublic.cta.primary": "Lançar workspace",
  "homePublic.cta.secondary": "Falar com um especialista",
  "wizard.welcome_title": "Bem-vindo ao assistente!",
  "wizard.welcome_image_alt": "Ilustração de boas-vindas",
  "wizard.welcome_description":
    "Configure seu perfil e preferências para começar a usar o sistema.",
  "wizard.profile_title": "Informações do Perfil",
  "wizard.profile_description": "Conte-nos sobre você e sua organização.",
  "wizard.preferences_title": "Preferências",
  "wizard.preferences_description":
    "Personalize sua experiência selecionando tema, idioma e outras opções.",
  "wizard.complete_title": "Pronto!",
  "wizard.complete_description": "Seu perfil foi configurado corretamente.",
  "wizard.feature_chat_title": "Chat Inteligente",
  "wizard.feature_chat_desc":
    "Faça perguntas e obtenha respostas precisas baseadas nos seus documentos.",
  "wizard.feature_docs_title": "Gestão de Documentos",
  "wizard.feature_docs_desc":
    "Envie, organize e consulte seus documentos facilmente.",
  "wizard.feature_insights_title": "Análises e Insights",
  "wizard.feature_insights_desc":
    "Obtenha análises e estatísticas relevantes dos seus dados.",
  "wizard.first_name": "Nomes",
  "wizard.first_name_required": "Os nomes são obrigatórios.",
  "wizard.lastname": "Sobrenome",
  "wizard.lastname_required": "Os sobrenomes são obrigatórios.",
  "wizard.name_required": "O nome é obrigatório.",
  "wizard.country": "País",
  "wizard.country_required": "O país é obrigatório.",
  "wizard.job_title": "Cargo",
  "wizard.job_required": "O cargo é obrigatório.",
  "wizard.company": "Empresa",
  "wizard.company_required": "A empresa é obrigatória.",
  "wizard.timezone": "Fuso horário",
  "wizard.timezone_select": "Selecione seu fuso horário",
  "wizard.timezone_required": "O fuso horário é obrigatório.",
  "wizard.timezone_search": "Buscar cidade ou fuso...",
  "wizard.timezone_no_results": "Sem resultados",
  "wizard.org_type": "Tipo de organização",
  "wizard.org_enterprise": "Empresa",
  "wizard.org_education": "Educação",
  "wizard.org_government": "Governo",
  "wizard.org_nonprofit": "ONG",
  "wizard.org_other": "Outro",
  "wizard.org_size": "Tamanho da organização",
  "wizard.size_small": "Pequena (1-50)",
  "wizard.size_medium": "Média (51-250)",
  "wizard.size_large": "Grande (251-1000)",
  "wizard.size_enterprise": "Corporativo (1000+)",
  "wizard.theme_preference": "Preferência de tema",
  "wizard.language_preference": "Preferência de idioma",
  "wizard.yes": "Sim",
  "wizard.no": "Não",
  "wizard.other_preferences": "Outras preferências",
  "wizard.enable_notifications": "Habilitar notificações",
  "wizard.allow_data_collection": "Permitir coleta de dados anônimos",
  "wizard.data_collection_info":
    "Seus dados ajudam a melhorar o sistema. Nenhuma informação pessoal é coletada.",
  "wizard.summary_title": "Resumo da configuração",
  "wizard.previous": "Anterior",
  "wizard.next": "Próximo",
  "wizard.complete": "Concluir",
  "wizard.save_error": "Erro ao salvar a configuração. Tente novamente.",
  "wizard.copy_support_reference": "Copiar código",
  "wizard.support_reference_copied": "Copiado",
  "wizard.second_name": "Apelido",
  "wizard.second_name_required": "O apelido é obrigatório.",
  filtered_results: "resultados filtrados",
  "invite.validating": "Validando convite...",
  "invite.invalid_or_expired": "Convite inválido ou expirado",
  "invite.invalid_or_expired_desc": "O link do convite não é mais válido. Peça um novo convite ao administrador.",
  "invite.missing_params": "Convite incompleto",
  "invite.missing_params_desc": "O link do convite não contém as informações necessárias para continuar.",
  "invite.not_found": "Convite não encontrado",
  "invite.not_found_desc": "Não encontramos um convite ativo para este e-mail.",
  "invite.server_error": "Não foi possível validar o convite",
  "invite.server_error_desc": "Ocorreu um erro ao validar o convite. Tente novamente mais tarde.",
  "invite.bad_request": "As informações enviadas não são válidas.",
  "invite.back_to_login": "Voltar ao login",
  "invite.email": "E-mail convidado",
  "invite.company": "Empresa",
  "invite.role": "Função",
  "invite.company_from_invite": "A empresa é definida pelo convite.",
  "invite.password_step": "Crie sua senha",
  "invite.password_step_desc": "Defina uma senha segura para concluir seu acesso.",
  "invite.password": "Senha",
  "invite.password_placeholder": "Digite sua senha",
  "invite.password_required": "A senha é obrigatória.",
  "invite.password_min_length": "A senha deve ter pelo menos 8 caracteres.",
  "invite.password_hint": "Use pelo menos 8 caracteres.",
  "invite.confirm_password": "Confirmar senha",
  "invite.confirm_password_placeholder": "Repita sua senha",
  "invite.passwords_not_match": "As senhas não coincidem.",
};
